<template>
  <UserPageTemplate :user="currentUser" @openContacts="openContacts">
    <SectionBox>
      <BasicSection>
        <ContentSection id="achievements" appearance="resume">
          <template #title>
            <InlineAlign gap="small">
              <template #start>
                <PageTitle title="Награды" />
              </template>
              <template #end>
                <BasicLink
                  target="_blank"
                  appearance="question"
                  href="/info/achievements"
                >
                  <span class="icon icon-question" />
                </BasicLink>
              </template>
            </InlineAlign>
          </template>
          <template #default>
            <AchievementsList
              :is-owner="user.isOwner"
              :achievements="achievements"
            /> </template
        ></ContentSection>
      </BasicSection>
    </SectionBox>
  </UserPageTemplate>
</template>

<script>
import { showErrorNotification } from 'src/services/api.js';
import { PersonalResource } from 'src/services/personal.js';

import AchievementsList from 'src/components/achievements/AchievementsList/AchievementsList.vue';
import BasicLink from 'src/components/BasicLink/BasicLink.vue';
import InlineAlign from 'src/components/InlineAlign/InlineAlign.vue';
import PageTitle from 'src/components/PageTitle/PageTitle.vue';
import SectionBox from 'src/components/SectionBox/SectionBox.vue';
import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';
import ContentSection from 'src/components/sections/ContentSection/ContentSection.vue';
import UserPageTemplate from 'src/components/users/UserPageTemplate/UserPageTemplate.vue';

export default {
  name: 'UserAchievementsPage',
  components: {
    ContentSection,
    InlineAlign,
    SectionBox,
    BasicSection,
    AchievementsList,
    UserPageTemplate,
    BasicLink,
    PageTitle,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    achievements: Array,
  },
  provide() {
    return {
      contactsConditions: this.user.contacts
        ? this.user.contacts.conditions
        : null,
      getContactsIsLoading: () => this.contactsIsLoading,
    };
  },
  data() {
    return {
      currentUser: this.user,
      contactsIsLoading: false,
    };
  },
  methods: {
    async openContacts() {
      this.contactsIsLoading = true;
      try {
        const response = await PersonalResource.getUserContacts(this.user.id);
        this.currentUser.contacts = response.data.contacts;
        if (this.currentUser.jobInviteButton?.showHint) {
          this.currentUser.jobInviteButton.showHint = false;
        }
      } catch (error) {
        showErrorNotification(error);
      } finally {
        this.contactsIsLoading = false;
      }
    },
  },
};
</script>
